module.exports = __webpack_public_path__ + "static/media/setup_kpis.a274566d.webp";